import React from 'react';
import ChevronIcon from '../../icons/chevronIcon';

const ModalForSelector = ({
  open = false,
  onClose,
  animationClass,
  fullScreen = false,
  children,
  showCloseButton = true,
  idModal,
  hasBackground = false,
  backIcon = false,
}) => {
  if (!open) return null;

  let fullscreenClass = fullScreen ? 'modal-fullscreen' : '';
  let modalClass = 'modal show d-block';

  const isModalFull = fullScreen ? {} : { position: 'absolute', top: 0, right: 0 };
  const modalContentStyle = fullScreen ? {} : { maxHeight: '80vh', overflowY: 'auto' };

  return (
    <div
      className={`${modalClass} ${animationClass} ${fullscreenClass}`}
      tabIndex='-1'
      role='dialog'
      aria-hidden='true'
      id={idModal}
      onClick={onClose}
    >
      <div
        className='modal-dialog modal-dialog-centered'
        role='document'
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`modal-content py-5 px-4 ${hasBackground && 'background-modal'}`}
          style={modalContentStyle}
        >
          {showCloseButton && backIcon && (
            <div className='ml-2' onClick={onClose}>
              <ChevronIcon fillColor='var(--color-primary)' size={'26px'} rotation={180} />
            </div>
          )}
          {showCloseButton && !backIcon && (
            <div style={isModalFull}>
              <button
                type='button'
                onClick={onClose}
                className='close font-large text-secondary'
                data-dismiss='modal'
                aria-label='Close'
              >
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalForSelector;
